import { useZustandGlobalLocalStore } from 'zustandGlobalLocalStore'
import { useZustandSessionStore } from 'zustandGlobalSessionStore'

export const resetLocalAndSessionStores = (): void => {
  const { frcSettledDate } = useZustandGlobalLocalStore.getState()
  const { ...globalLocalStoreInitialState } =
    useZustandGlobalLocalStore.getInitialState()
  useZustandGlobalLocalStore.setState({
    ...globalLocalStoreInitialState,
    frcSettledDate,
  })

  const { ...useZustandSessionStoreInitialState } =
    useZustandSessionStore.getInitialState()
  useZustandSessionStore.setState(useZustandSessionStoreInitialState)
}
